export const defaultboard = [
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ],
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ],
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ],
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ],
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ],
  [
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" },
    { letter: "", color: "white" }
  ]
]
